import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export default function Pagination({ current, total, onChange }) {
  const handlePagination = (page) => {
    if (page < 1 || page > total) return;
    onChange(page);
  };

  const PageItem = ({ page }) => (
    <button
      onClick={() => handlePagination(page)}
      className={`px-3 py-1.5 rounded-md border text-sm transition ${
        current === page
          ? "bg-brand text-white border-brand"
          : "bg-white hover:bg-gray-100 border-gray-300 text-gray-700"
      }`}
    >
      {page}
    </button>
  );

  const renderPages = () => {
    // Case 1: total pages ≤ 4 → show all
    if (total <= 4) {
      return Array.from({ length: total }, (_, i) => (
        <PageItem key={i} page={i + 1} />
      ));
    }

    // Case 2: User near beginning (1,2,3,..)
    if (current <= 2) {
      return (
        <>
          <PageItem page={1} />
          <PageItem page={2} />
          <PageItem page={3} />
          <span className="px-2 text-gray-400">…</span>
          <PageItem page={total} />
        </>
      );
    }

    // Case 3: User near end
    if (current >= total - 1) {
      return (
        <>
          <PageItem page={1} />
          <span className="px-2 text-gray-400">…</span>
          <PageItem page={total - 2} />
          <PageItem page={total - 1} />
          <PageItem page={total} />
        </>
      );
    }

    // Case 4: User in middle
    return (
      <>
        <PageItem page={1} />
        <span className="px-2 text-gray-400">…</span>
        <PageItem page={current - 1} />
        <PageItem page={current} />
        <PageItem page={current + 1} />
        <span className="px-2 text-gray-400">…</span>
        <PageItem page={total} />
      </>
    );
  };

  return (
    <div className="flex items-center justify-center gap-2 mt-6 select-none">
      {/* Previous */}
      <button
        className="px-3 py-1.5 rounded-md border bg-white hover:bg-gray-100 text-gray-600 disabled:opacity-40"
        disabled={current === 1}
        onClick={() => handlePagination(current - 1)}
      >
        <FaChevronLeft className="w-3 h-3" />
      </button>

      {/* Page Buttons */}
      {renderPages()}

      {/* Next */}
      <button
        className="px-3 py-1.5 rounded-md border bg-white hover:bg-gray-100 text-gray-600 disabled:opacity-40"
        disabled={current === total}
        onClick={() => handlePagination(current + 1)}
      >
        <FaChevronRight className="w-3 h-3" />
      </button>
    </div>
  );
}
